import request from '@/api/request.js'

/**
 * 音效结构化资源信息与正文接口。
 *
 * 该模块只维护歌手、专辑、封面以及歌词/台词正文，不和标签、
 * 搜索词或版权接口混写，防止编辑一个区域时意外覆盖另一个区域的数据。
 */
const apis = {
  /**
   * 获取正文类型和语言选项。
   *
   * @returns {Promise}
   */
  options() {
    return request({ url: '/admin_sound_resource/options', method: 'GET' })
  },

  /**
   * 读取单个音效的结构化资源信息。
   *
   * @param {Object} params 必须包含 sound_id
   * @returns {Promise}
   */
  read(params) {
    return request({ url: '/admin_sound_resource/read', method: 'GET', params })
  },

  /**
   * 保存资源元数据和歌词、台词、语音转写正文。
   *
   * @param {Object} data 包含 sound_id、meta 和 contents
   * @returns {Promise}
   */
  save(data) {
    return request({ url: '/admin_sound_resource/save', method: 'POST', data })
  },

  /**
   * 解除当前音效与公共图片资源的封面引用。
   *
   * @param {Object} data 必须包含 sound_id
   * @returns {Promise}
   */
  removeCover(data) {
    return request({ url: '/admin_sound_resource/removeCover', method: 'POST', data })
  }
}

export default apis
